module.exports = __webpack_public_path__ + "img/lunbo111.ad5a859.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo111.png
// module id = SFGz
// module chunks = 0